import React, { useEffect, useState } from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
  showLoader?: boolean;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ 
  children, 
  className = '',
  showLoader = true
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Primeiro mostra o loader
    if (showLoader) {
      const loaderTimer = setTimeout(() => {
        setShowContent(true);
      }, 300);
      
      return () => clearTimeout(loaderTimer);
    } else {
      setShowContent(true);
    }
  }, [showLoader]);

  useEffect(() => {
    if (showContent) {
      // Pequeno delay para garantir que a animação seja visível
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [showContent]);

  if (!showContent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-slate-600 text-sm">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} 
        transition-all duration-700 ease-out transform
        ${className}
      `}
      style={{ 
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(32px) scale(0.98)',
        opacity: isVisible ? 1 : 0,
        filter: isVisible ? 'blur(0px)' : 'blur(1px)'
      }}
    >
      {children}
    </div>
  );
};
